import React, { useMemo } from 'react';

import { decodeCronString, getFriendlyDayName, CRON_PERIODS, CRON_MONTHS } from 'utils/recurring';

import DateTime from 'components/DateTime';
import TaskGroupName from 'components/task-group-name';

const ResourceRepeatText = ({ type, cron, trigger }) => {
    const cronTextElement = useMemo(() => {
        const cronProps = decodeCronString(cron);
        const [hours, minutes] = cronProps.cronStartAt.split(':');
        const startAtDate = new Date();
        startAtDate.setHours(hours - 0);
        startAtDate.setMinutes(minutes - 0);

        const startAtElement = <DateTime format="time">{ startAtDate }</DateTime>;

        switch (cronProps.cronType) {
            case 'period':
                return (
                    <React.Fragment>
                        { CRON_PERIODS[cronProps.cronMonth] } on { cronProps.cronDayOfMonth } at { startAtElement }
                    </React.Fragment>
                );

            case 'year':
                return (
                    <React.Fragment>
                        Annually on { cronProps.cronDayOfMonth } of { CRON_MONTHS[cronProps.cronMonth] } at ${ startAtElement }
                    </React.Fragment>
                );

            case 'month':
                return (
                    <React.Fragment>
                        Monthly on { cronProps.cronDayOfMonth } at { startAtElement }
                    </React.Fragment>
                );
        }

        if (cronProps.cronType === 'week' || cronProps.cronDayOfWeek.length === 1) {
            return (
                <React.Fragment>
                    Weekly on { getFriendlyDayName(cronProps.cronDayOfWeek[0]) } at { startAtElement }
                </React.Fragment>
            );
        }

        if (cronProps.cronDayOfWeek.length === 7) {
            return (
                <React.Fragment>
                    Daily at { startAtElement }
                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
                { cronProps.cronDayOfWeek.map(day => getFriendlyDayName(day, true)).join(', ') } at { startAtElement }
            </React.Fragment>
        );
    }, [cron]);

    if (type === 'status') {
        return (
            <React.Fragment>
                When in <TaskGroupName id={trigger} />
            </React.Fragment>
        )
    }

    if (type === 'completion') {
        return (
            <React.Fragment>
                When marked completed
            </React.Fragment>
        );
    }

    if (cron) {
        return cronTextElement;
    }

    return null;
}

export default ResourceRepeatText;
